axboot.tabView = {
    getTabIndex : function () {
        return this.getActiveTab().panelIndex;
    },
    getActiveTab : function () {
        return axboot.util.getActiveTab(this.target.ax5layout('getActiveTab'));
    },
    setOpenTab : function (tabIndex) {
        this.target.ax5layout('tabOpen', tabIndex);
    }
}